import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';

const SectionCard = props => {

    return (
        <div className="card--block--rounded">
            <Link className={ `icon--card ${props.iconClass} ` } to={ props.link }></Link>
            <h3 className="title--card main-color">
                <Link to={ props.link }>
                    { props.title }
                </Link>
            </h3>
            <p>{ReactHtmlParser( props.text )}</p>
            <p className="btn--card--block">
                <Link to={ props.link }
                    className="btn--card main-color">
                    { ReactHtmlParser(props.seeMore) }
                </Link>
            </p>
        </div>
    )
}

export default SectionCard;